<template>
  <div class="cr-panel statement-effects">
    <div class="cr-panel-head">
      <div class="cr-panel-title">
        <fa-icon :icon="['fal', 'calculator']" class="cr-panel-icon"/>
        O que muda ao aplicar
      </div>
      <div class="cr-panel-subtitle">
        Título e repasses são ajustados na mesma operação. Nada é gravado até você clicar em
        Aplicar.
      </div>
    </div>
    <div class="empty cr-panel-empty" v-if="empty">
      <div class="empty-icon"><fa-icon :icon="['fal', 'info-circle']" size="2x"/></div>
      <p class="empty-subtitle">
        Nenhum efeito financeiro: o arquivo não traz glosa para os lotes conciliados.
      </p>
    </div>
    <div class="bg-impact" v-else>
      <div class="bg-impact-row" v-for="batch in effects.batches" :key="String(batch.id)">
        <div><b>Lote {{ batch.number }}</b></div>
        <div>
          <span class="bg-pill" :class="statusClass(batch.from)">{{ statusName(batch.from) }}</span>
          <span class="bg-impact-arrow"><fa-icon :icon="['fal', 'arrow-right']"/></span>
          <span class="bg-pill" :class="statusClass(batch.to)">{{ statusName(batch.to) }}</span>
        </div>
        <div></div>
        <div class="bg-impact-state text-gray">
          {{ batch.glosses }} {{ batch.glosses === 1 ? 'glosa criada' : 'glosas criadas' }}
          · −{{ batch.glossedTotal | currency }}
        </div>
      </div>
      <impact-line v-for="change in effects.receivableChanges" :key="`r-${String(change.bundleId)}`"
                   :label="change.document || `LOTE ${change.number}`"
                   :from="change.from" :to="change.to" :delta="change.delta"
                   :paid="change.paid" kind="receivable"/>
      <impact-line v-for="change in effects.transferChanges" :key="transferKey(change)"
                   :label="change.name || 'Profissional'"
                   :detail="change.number ? `REPASSE LOTE ${change.number}` : null"
                   :from="change.from" :to="change.to" :delta="change.delta"
                   :paid="change.paid || change.adjustment" kind="transfer"/>
    </div>
  </div>
</template>

<script>
import ImpactLine from './ImpactLine.vue';
import { batchStatuses, batchStatusClasses } from '../helpers';

export default {
  components: {
    ImpactLine,
  },
  props: {
    effects: {
      type: Object,
      required: true,
    },
  },
  computed: {
    empty() {
      return (this.effects.batches || []).length === 0;
    },
  },
  methods: {
    transferKey(change) {
      return `t-${String(change.bundleId || change.professionalId)}`;
    },
    statusName(status) {
      return batchStatuses[status] || status;
    },
    statusClass(status) {
      return batchStatusClasses[status] || 'bg-pill-gray';
    },
  },
};
</script>
